import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import Book from './Assets/BOOK.png';
import Netflix from './Assets/Netflix.png';
import Todo from './Assets/Todo.png';
import Razer from './Assets/Razer.png';

export default function Projects() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cardStyle = {
    boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
    transition: '0.3s',
    borderRadius: '8px',
  };

  return (
    <div className='py-1' style={{ backgroundColor: '#f5f6ff' }}>
      <center className='fs-1 mt-5'><strong>PROJECTS</strong></center>

      <div className='container mt-5'>
        <div className='row'>

          <div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
            <Card className='h-100' style={cardStyle}>
              <Card.Img variant='top' src={Book} />
              <Card.Body>
                <center><Card.Title>BOOK MY TICKET</Card.Title></center><hr />
                <Card.Text className='text' style={{ textAlign: 'justify' }}>
                  The Book My Ticket web application allows users to book movie tickets for a selected film and theater. It is designed to enhance the user experience of choosing seats and proceeding with the booking process. The application is built using HTML, CSS, and JavaScript.
                </Card.Text>
                <center><Button variant='primary text-light'><a href="https://bookmyticket-ten.vercel.app/" target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none', color: 'white' }}>Click here to View</a></Button></center>
              </Card.Body>
            </Card>
          </div>

          <div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
            <Card className='h-100' style={cardStyle}>
              <Card.Img variant='top' src={Netflix} />
              <Card.Body>
                <center><Card.Title>NETFLIX_CLONE</Card.Title></center><hr />
                <Card.Text className='text' style={{ textAlign: 'justify' }}>
                  NETFLIX is a responsive web application that emulates the front-end design and functionality of the Netflix streaming service. The application is built using HTML, CSS, and JavaScript. The application is purely front-end, users cannot access actual streaming content or personalized recommendations.
                </Card.Text>
                <center><Button variant='primary text-light'><a href="https://netflixclone-omega-fawn.vercel.app/" target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none', color: 'white' }}>Click here to View</a></Button></center>
              </Card.Body>
            </Card>
          </div>
          
          <div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
            <Card className='h-100' style={cardStyle}>
              <Card.Img style={{ height: '187px' }} variant='top' src={Todo} />
              <Card.Body>
                <center><Card.Title>TO-DO APP</Card.Title></center><hr />
                <Card.Text className='text' style={{ textAlign: 'justify' }}>
                  A To-do application is that allows users to manage and organize their tasks. This application is designed to provide users with a straightforward and user-friendly interface for creating, viewing, updating, and deleting tasks. The application can be built using HTML, CSS, and JavaScript.
                </Card.Text>
                <center><Button variant='primary text-light'><a href="https://todo-app-ashy-ten.vercel.app/" target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none', color: 'white' }}>Click here to View</a></Button></center>
              </Card.Body>
            </Card>
          </div>

          <div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
          <Card className='h-100' style={cardStyle}>
            <Card.Img variant='top' src={Razer} />
            <Card.Body>
              <center><Card.Title>Razer App</Card.Title></center><hr />
              <Card.Text className='text' style={{ textAlign: 'justify' }}>

              
Razer's React-powered web app offers a sleek platform for browsing their latest gaming gear. Users can explore peripherals and laptops with ease. While it doesn't include streaming content or personalized recommendations, it provides a dynamic front-end experience, perfect for gamers looking to upgrade their setup.           </Card.Text>
              <center><Button variant='primary text-light'><a href="https://razer-app.netlify.app/" target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none', color: 'white' }}>Click here to View</a></Button></center>
            </Card.Body>
          </Card>
        </div>

        </div>
      </div>


      <div className="footer bg-secondary text-white p-3">
      <Container className="px-0">
      <Row className="justify-content-center align-items-center">
        <Col xs={12} sm={4} className="mb-3 mb-sm-0 text-center text-sm-start">
          <h6>Designed & Developed by <a href="https://www.linkedin.com/in/arenaveenkumar" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><strong className='text-warning'>ARE NAVEEN KUMAR</strong></a></h6>
        </Col>
        <Col xs={12} sm={4} className="text-center mb-4 mb-sm-0">
          <h6 className="mb-0"><i className="fa-regular fa-copyright "></i> Copyright-2024</h6>
        </Col>
        <Col xs={12} sm={4} className="d-flex justify-content-center justify-content-sm-end">
          <a href="https://www.linkedin.com/in/arenaveenkumar/" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in fs-4"></i></a>
          <a href="https://github.com/arenaveenkumar" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-github fs-4"></i></a>
          <a href="https://www.instagram.com/arenaveenkumar_" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram fs-4"></i></a>
          <a href="https://wa.me/918096858075" className="text-white" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp fs-4"></i></a>

        </Col>
      </Row>
    </Container>
      </div>

    </div>
  );
}
